export enum ReportSection {
  InstitutionDetails = 'InstitutionDetails',
  InstitutionInvestmentApproach = 'InstitutionInvestmentApproach',
  FinancialHighlights = 'FinancialHighlights',
  EquityPortfolio = 'EquityPortfolio',
  HistoricalOwnership = 'HistoricalOwnership',
  ActivityHistory = 'ActivityHistory',
  Notes = 'Notes',
  InstitutionBaseInfo = 'InstitutionBaseInfo',
  ContactBaseInfo = 'ContactBaseInfo',
  ContactBiography = 'ContactBiography',
  SustainabilityFocus = 'SustainabilityFocus',
  Targeting = 'Targeting',
  PeerOwnership = 'PeerOwnership',
  SuitabilityFactors = 'SuitabilityFactors',
  PrimaryContactBiography = 'PrimaryContactBiography',
  CustomFields = 'CustomFields',
  FundSummary = 'FundSummary',
  DrPriceVolume = 'DRPriceVolume',
  YtdPriceVolume = 'YTDPriceVolume',
  CrossBorderBrokerActivity = 'CrossBorderBrokerActivity',
  None = 'None',
  Disclosure = 'Disclosure',

  TradingAnalysisAll = 'TradingAnalysisAll',
  TradingAnalysisBuys = 'TradingAnalysisBuys',
  TradingAnalysisSells = 'TradingAnalysisSells',

  PredictedMovements = 'PredictedMovements',
  StyleName = 'StyleName',
  HolderRegionName = 'HolderRegionName',
  HolderInvestmentCenterName = 'HolderInvestmentCenterName',
  HolderCountryName = 'HolderCountryName',
  SustainabilityFitMetric = 'SustainabilityFitMetric',
  ParticipantBiography = 'ParticipantBiography',
  Orientation = 'Orientation',
  InvestorTypeInstitutions = 'InvestorTypeInstitutions',
  Activist = 'ActivistOwnershipInstitutions',
  Turnover = 'Turnover',
  CombinedOwnership = 'CombinedOwnership',
  MonthlyDrActivity = 'MonthlyDrActivity',

  TradingActivity = 'TradingActivity',
  ActivityIndicators = 'ActivityIndicators',
  CrossBorderTrading = 'CrossBorderTrading',
  WeekPriceVolume = 'WeekPriceVolume',
  DRIssueAndCancelActivity = 'DRIssueAndCancelActivity',
  HighTradingVolumeBrokers = 'HighTradingVolumeBrokers',
  DepositaryReceiptsContact = 'DepositaryReceiptsContact',
  PriceActivity = 'PriceActivity',
  TopHolders = 'TopHolders',
  TopBuyersSellers = 'TopBuyersSellers',
  BnyHeader = 'BnyManagementReportHeaderInfo',
  ItineraryComments = 'ItineraryComments',
  ItineraryActivityHeader = 'ItineraryActivityHeader',
  ItineraryParticipantInfo = 'ItineraryParticipantInfo',
  ItineraryActivityAttributes = 'ItineraryActivityAttributes',
  ItineraryParticipantBio = 'ItineraryParticipantBio',
  ItineraryActivityHistory = 'ItineraryActivityHistory',
  ItineraryPeerOwnership = 'ItineraryPeerOwnership',

  TopShareHolders = 'TopShareHolders',
  OwnershipAnalyticsComments = 'OwnershipAnalyticsComments',
  StylesInstitutions = 'StyleInstitutions',
  PeerOwnershipComments = 'PeerOwnershipComments',
  PeerOwnershipInstitutionsGlobalRegion = 'PeerOwnershipInstitutionsGlobalRegion',
  PeerOwnershipInstitutionsCountryTerritory = 'PeerOwnershipInstitutionsCountryTerritory',
  PeerOwnershipInstitutionsTopInvestmentCenters = 'PeerOwnershipInstitutionsTopInvestmentCenters',
  CurrentPeerOverweightInstitutions = 'CurrentPeerOverweightInstitutions',
  OpportunityLevel = 'OpportunityLevel',
  AggregatedPeerFocus = 'AggregatedPeerFocus',
  PeerOwnershipInstitutions = 'PeerOwnershipInstitutions',
  PeerOwnershipProspectiveShareholderInstitutionsGlobal = 'PeerOwnershipProspectiveShareholderInstitutionsGlobal',
  TurnoverInstitutions = 'TurnoverInstitutions',
  OrientationInstitutions = 'OrientationInstitutions',
  HistoricalInstitutionalVsNonFilersInstitutions = 'HistoricalInstitutionalVsNonFilersInstitutions',
  PeerOwnershipMovements = 'PeerOwnershipMovements',
  TopPeerHolders = 'TopPeerHolders',
  PeerOwnershipHoldings = 'PeerOwnershipHoldings',
  TopInstitutionsHoldersTotalPeerOwnership = 'TopInstitutionsHoldersTotalPeerOwnership',

  AiSummaryCard = 'AiSummaryCard'
}
